import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const QualityControlCountDown = ({ secondsInput, sound, stopSound, isCountDown, typeQC, haveVIPQC }) => {
    const [remainingSeconds, setRemainingSeconds] = useState(secondsInput)
    const location = useLocation()
    sound.loop = true // Bật loop âm thanh

    useEffect(() => {
        setRemainingSeconds(secondsInput)
    }, [])

    useEffect(() => {
        if (remainingSeconds < 3 && !sound.playing && isCountDown) {
            // Phát âm thanh từ 2 giây cuối, chỉ phát nếu chưa phát
            sound.play().catch((err) => console.error("Error playing sound:", err))
        }

        if (remainingSeconds > 0 && isCountDown) {
            // Tạo timer để giảm thời gian mỗi giây
            const timerId = setInterval(() => {
                setRemainingSeconds((prev) => prev - 1)
            }, 1000)

            return () => clearInterval(timerId) // Dọn dẹp timer khi unmount hoặc reset
        }

        return () => { } //xử lý gì khi bộ đếm kết thúc
    }, [remainingSeconds, isCountDown, secondsInput])

    useEffect(() => {
        // Dừng âm thanh khi URL thay đổi
        return () => {
            sound.pause()
            sound.currentTime = 0
        }
    }, [location])

    const resetCountdown = () => {
        stopSound()
    }

    const calculateTimeLeft = (seconds) => {
        const days = Math.floor(seconds / (60 * 60 * 24))
        const hours = Math.floor((seconds / (60 * 60)) % 24)
        const minutes = Math.floor((seconds / 60) % 60)
        const secondsLeft = Math.floor(seconds % 60)

        return { days, hours, minutes, seconds: secondsLeft }
    }

    const timeLeft = calculateTimeLeft(remainingSeconds)
    const { days = 0, hours = 0, minutes = 0, seconds = 0 } = { ...timeLeft }

    // Format dữ liệu hiển thị
    const formattedTime =
        remainingSeconds > 0
            ? (days ? `${days} day${days !== 1 ? 's' : ''} ` : '') +
            (hours ? `${String(hours).padStart(2, '0')}:` : '') +
            `${String(minutes).padStart(2, '0')}:` +
            `${String(seconds).padStart(2, '0')}`
            : "Hết thời gian QC!"

    const textClass = `${(!days && !hours && !minutes && seconds < 6) ? `${isCountDown ? `text-blink` : ''} text-danger` : 'text-success'} font-weight-bold mb-0`
    const textStyle = {
        fontSize: '2.5rem',
        position: 'fixed',
        right: 0,
        top: '37px',
        zIndex: 999999999,
        background: '#fff',
        borderRadius: 10,
        padding: '0 48px'

    }

    return (
        <div className='d-flex align-items-center' style={{ background: "#fff" }}>
            <h2 className={textClass} style={textStyle}>{formattedTime}</h2>
            {/* <button onClick={resetCountdown}>Reset Countdown</button> */}
        </div>
    )
}

export default QualityControlCountDown